/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { cardIssuingList } from "../../funcs/cardIssuingList.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListIssuedCardsRequest$inboundSchema,
};

export const tool$cardIssuingList: ToolDefinition<typeof args> = {
  name: "card-issuing-list",
  description: `List Moov issued cards existing for the account.

To access this endpoint using an [access token](https://docs.moov.io/api/authentication/access-tokens/) 
you'll need to specify the \`/accounts/{accountID}/issued-cards.read\` scope.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await cardIssuingList(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
